import {MaterialType} from '@domain/materials'

export type UrlParams = Record<
  | 'plantCode'
  | 'page'
  | 'assetType'
  | 'assetId'
  | 'materialType'
  | 'materialId'
  | 'nodeId'
  | 'nodeTab'
  | '*',
  string | undefined
>

export type SearchParams = typeof searchParams
export const searchParams = {
  materialType: Object.values(MaterialType),
  measurementTypesCategory: [] as string[]
}
